import { defineComponent as _defineComponent } from 'vue'
import LoginGif from "@/assets/images/roomLoding.gif";
import { usePiniaState } from "@/store/userPinia";
import { roomPiniaState } from "@/store/roomPinia";
import { storeToRefs } from "pinia";
import { Toast } from "vant";
import { ref, onUpdated, onUnmounted, onMounted, watch } from "vue";
import EventBus from "@/uitls/EventBus";
import { ChatUtils } from "@/uitls/ChatUtils";
import { userLookOrSend } from "@/api/php/player";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { YMPush } from "@/uitls/uitls";
import Platform from "@/config/platform";
import router from "@/router";
import { encryptionFocusHost } from "@/api/php/user";
import { checkSetNickname, nativeToLogin, toLocationBrowser } from "@/uitls/native";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
import { get_room_history_msg } from "@/network/socket/SocketReq";
import Clipboard from "clipboard";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'


import biaoqing from "@/assets/images/biaoqing.png";
import sendBtn from "@/assets/images/sendBtn.png";
import { toMsgChat } from "@/uitls/native";
import IMUtils from "@/network/socket/imUtils";
import { msg_get_user_info } from "@/network/socket/SocketReq";
import { getImUserByFid } from "@/network/db/dbServe";
interface dataProps {
  setdata: any;
  height: number;
}

export default /*#__PURE__*/_defineComponent({
  name: 'PlayerChat',
  props: {
    setdata: { type: null, required: true },
    height: { type: Number, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  setdata: any;
  height: number;
}

const zbgg = require(`@/assets/${process.env.VUE_APP_NAME}/zbgg.png`)
const copy_id = require(`@/assets/${process.env.VUE_APP_NAME}/copy_id.gif`)
const vip0 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_0.png`)
const vip1 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_1.png`)
const vip2 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_2.png`)
const vip3 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_3.png`)
const vip4 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_4.png`)
const vip5 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_5.png`)
const roomZb = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)
const welcome_icon = require(`@/assets/${process.env.VUE_APP_NAME}/welcome_icon.png`)

const { t } = useI18n()
const ConfigpiniaStore = serverConfigPiniaState();
const { msgShield, chat_ad_interval, web_pm_tips } = storeToRefs(ConfigpiniaStore);

const userStore = usePiniaState();
const roomStore = roomPiniaState();
const { isYk, user } = storeToRefs(userStore);
const { addMsgList, roomSendMsg, addMsgItem, delMsg, changeMsgAD } = roomStore;
const { isJoin, msgList, roomId, active } = storeToRefs(roomStore);
const route = useRoute();
const room_key = ref('');
const anchor_id = ref('');
const marqueeColor = process.env.VUE_APP_MARQUEE_COLOR as string;
const marqueeFontColor = process.env.VUE_APP_MARQUEE_FONT_COLOR as string;
const mainColor = process.env.VUE_APP_MAINCOLOR as string;

const scrollerRef = ref(null);

//输入的文字
const inputValue = ref("");
//10分钟后发送
let onsend10 = true;



onMounted(() => {
  if (isJoin.value && msgList.value.length == 0) {
    get_room_history_msg(roomId.value);
  }
  setTime();
  scrollIntoView();
});

const scrollIntoView = () => {
  //解决移动端键盘遮挡问题
  window.addEventListener("resize", resetResize);
}

const resetResize = () => {
  document.activeElement.scrollIntoView(true);
}

watch(msgList, (oldValue, newValue) => {
  scrollToBottom();
})

const showAlertUser = ref(false)
const alertUserData = ref(null)


var sendTimeout
const setTime = () => {
  //10分钟后，发送一下服务器
  sendTimeout = setTimeout(() => {
    sendServer(3);
  }, 1000 * 600);
};
//用户观看10分钟，或聊天调用
const sendServer = async (type) => {
  console.log("用户观看10分钟，或聊天调用");
  if (!onsend10 || isYk.value) return;
  let result: any = await userLookOrSend({ type });
  if (result.code == 200) {
    onsend10 = false;
  }
};

//监听加入直播间成功
EventBus.on("RoomMsgList", (data: []) => {
  if (GetAD.value) return;
  addMsgList(data);
  //获取广告

  getAdFn()
  GetAD.value = true;
  setTimeout(() => {
    scrollToBottom();
  }, 1000);

});
const GetAD = ref(false)
const newAD = ref(false)
const anchor_announcement = ref({ content: [], title: '' })
let t1 = null;
const new_title_h = ref();
const ispack_up = ref(true);


var room_ad_status = 0; //是否开启广告
const getAdFn = async () => {
  const data = props.setdata;

  if (data && data.room_ad_data && data.room_ad_data.length) {
    newAD.value = true;
    // data.room_ad_data[0].fid = '123456'
    anchor_announcement.value = {
      content: data.room_ad_data,
      title: data.room_ad_title,
    }

    console.log('room_ad_data', data);


    if (data.room_ad_status == 1) {
      room_ad_status = 1;
      changeMsgAD({
        msgtype: 999,
        interval: parseInt(chat_ad_interval.value)
      })
    }
    YMPush('MAIN', '发送欢迎语');
  }
}
//消息撤回
EventBus.on("roomDelMsg", (index: number) => {
  delMsg(index);
});
//聊天广告进来了
EventBus.on("messageAd", (data: any) => {
  changeMsgAD(data)
});
onUnmounted(() => {
  window.removeEventListener("resize", resetResize);
  EventBus.off("RoomMsgList");
  EventBus.off("msg_join_chatroom_nty");
  EventBus.off("ChatRoomMsgItem");
  EventBus.off("roomDelMsg");
  EventBus.off("messageAd");
  document
    .querySelector("body")
    .setAttribute("style", "background-color:#f8f8f8;");
  clearTimeout(sendTimeout)
  clearInterval(t1)
  // addMsgList([]);
});

const joinUser = ref("");

//显示动画
const showAnimation = ref(false);
var showAnimationTime = 10;
var showAnimationRef = null;

//xxx进入了直播间
EventBus.on("msg_join_chatroom_nty", (data: any) => {
  if (data.roomkey == roomId.value) {
    let name: string = data.base_data.nickname;
    if (name.length > 11) {
      name = name.substring(0, 11);
    }
    const str = t('play.joinInRoom')
    joinUser.value = `${name} ${str}`;
    showAnimation.value = true;
    if (showAnimationRef) {
      showAnimationTime = 10;
    } else {
      showAnimationRef = setInterval(() => {
        showAnimationTime--;
        if (showAnimationTime < 1) {
          showAnimation.value = false;
          clearInterval(showAnimationRef);
          showAnimationTime = 10;
          showAnimationRef = null;
        }
      }, 1000);
    }
  }
});
let numInterval = 0
//消息进来了
EventBus.on("ChatRoomMsgItem", (msg: any) => {
  const { data, result } = msg;
  if (result == 45) {
    return;
  }
  // console.log('data',data);
  addMsgItem(data);
  numInterval++;
  // data.forEach((item, numInterval) => {
  // console.log('numInterval % parseInt(chat_ad_interval.value)',numInterval % parseInt(chat_ad_interval.value));

  if (room_ad_status && numInterval % parseInt(chat_ad_interval.value) === 0) {
    changeMsgAD({
      msgtype: 999,
      interval: parseInt(chat_ad_interval.value)
    })
  }
  if (isScrollBottom.value) {
    scrollToBottom();
  }
});


const scrollToBottom = () => {
  scrollerRef.value.scrollToBottom();
}


const isScrollBottom = ref(false);

const handleScroll = () => {
  const scroller = scrollerRef.value.$el;
  if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight) {
    isScrollBottom.value = true;
  } else {
    isScrollBottom.value = false;
  }
}


var sendtime = 0;

const sendMsg = () => {
  scrollDisabled.value = true;
  inputValue.value = inputValue.value.trim();
  if (inputValue.value == "") {
    return Toast.fail(t('me.tpisnodata'));
  }
  if (!checkSetNickname(user.value.fname, user.value.phone)) {
    return false;
  }
  // inputValue.value = JSON.stringify(inputValue.value.trim());
  YMPush("DOWNLOAD", "聊天框发言")
  const nowTime = new Date().getTime();
  let timeNum = 0;
  let ischina = /^[\u4e00-\u9fa5]+$/.test(inputValue.value)


  if (Platform.chartSendTime !== 0) {
    timeNum = parseInt(Platform.chartSendTime.toString());
  }
  if (nowTime - sendtime < timeNum * 1000) {
    return Toast.fail(t('me.ltpf'));
  }
  console.log('发送了==》', inputValue.value);
  let sendStr = inputValue.value;
  if (user.value.usertype == 0) {
    sendStr = checkMsgShield(inputValue.value)
  }

  roomSendMsg(sendStr);
  inputValue.value = "";
  showShare.value = false;
  sendServer(2);
  sendtime = new Date().getTime();
  window.$apiNet.statisticsPost({ room_key: room_key.value, anchor_id: anchor_id.value, action_id: '14' });// 统计打点
};

const openBiaoqing = () => {
  showShare.value = !showShare.value;
};

//页面刷新，滚动到最底部
onUpdated(() => {
  console.log('playerchat updated');

  if (scrollDisabled.value) {
    updateScrollTop();
  }
});

const getUidByFid = (fid: number): Promise<Number> => {
  return new Promise((resolve, reject) => {
    let handler = (evt: any) => {
      if (evt.fid && evt.fid == fid) {
        resolve(evt.uid);
        EventBus.off('imchatUser', handler)
      }
    }
    EventBus.on("imchatUser", handler);

    getImUserByFid(fid).then((user) => {
      if (!user) {
        resolve(user.uid);
      } else {
        msg_get_user_info(0, fid);
      }
    }).catch((e) => {
      msg_get_user_info(0, fid);
    })
  });
}

const onMsgChatClick = async (uid) => {
  // let uid = await getUidByFid(fid);
  
  const chatkey = IMUtils.createChatKey(Number(uid)).toString();

  toMsgChat(router, uid, chatkey);
}

const updateScrollTop = () => {
  if (active.value == 'chatroom') {
    // container.scrollIntoView();
    setTimeout(() => {
      let container = document.getElementById('playerTabs');
      if (container) {
        let tabContentEle: any = container.getElementsByClassName("van-tabs__content");
        if (tabContentEle && tabContentEle.length > 0) {
          tabContentEle[0].scrollTop = container.scrollHeight + container.clientHeight;
        }
      }
    }, 1000)
  }
}
const getLV = (lv: number) => {
  switch (lv) {
    case 0:
      return vip0;
    case 1:
      return vip1;
    case 2:
      return vip2;
    case 3:
      return vip3;
    case 4:
      return vip4;
    case 5:
      return vip5;
    default:
      return vip0;
  }
};

const getNickNameColor = (isadmin) => {
  //type 0是用户昵称，1是聊天内容

  if (isadmin == 0) {
    return "#007EFF";
  } else {
    return "#F3703B";
  }

};
const showShare = ref(false);

//选中了表情
const selBq = (name) => {
  inputValue.value = inputValue.value + name;
};
const bqSwpierList = ChatUtils.renderBq();

const toAD = (url) => {
  toLocationBrowser(url);
  // window.location.href = url;
}

//滚动条可以滑动
const scrollDisabled = ref(true)

//防抖
var timeout;
const debounce = (func, wait = 10000, immediate = false) => {
  if (inputValue.value !== "") {
    //设置状态，不再滚动
    console.log("不能滚动了");

    scrollDisabled.value = false
  }
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout);
  // 立即执行，此类情况一般用不到
  if (immediate) {
    var callNow = !timeout;
    timeout = setTimeout(function () {
      timeout = null;
    }, wait);
    if (callNow) typeof func === 'function' && func();
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(function () {
      typeof func === 'function' && func();
    }, wait);
  }
}

const changeInputType = () => {
  //设置状态，可以滚动
  scrollDisabled.value = true;
}

const checkMsgShield = (text: string) => {
  if (msgShield.value && msgShield.value.length > 0) {
    //替换字符串
    String.prototype.replaceAll = function (s1, s2) {
      return this.replace(new RegExp(s1, "gm"), s2);
    }

    for (let i = 0; i < msgShield.value.length; i++) {
      let star = '';
      let tmp = msgShield.value[i];
      for (let j = 0; j < tmp.length; j++) {
        star += "*";
      }
      try {
        text = text.replaceAll(msgShield.value[i], star);
      } catch (error) { }
    }
  }
  return text;
}

const toStart = async () => {
  if (isYk.value) {
    return nativeToLogin(router);
  }
  //关注这个主播
  const res: any = await encryptionFocusHost({
    host_id: JSON.stringify([alertUserData.value.id])
  })
  if (res.code == 200) {
    Toast.success(t('me.gzcg'))
    showAlertUser.value = false;
  } else {
    Toast.fail(res.msg)
  }
}

const clickHandle = (e) => {
  // console.log(e.target.nodeName);
  // console.log(e.target.innerHTML);
  if (e.target.nodeName == "A") {
    toLocationBrowser(e.target.innerHTML);
    // 统计打点
    window.$apiNet.statisticsPost({ action_id: '2' });
  }
}

const handleFalse = () => {
  return false
}

// 处理链接消息
const msgurl = (txt) => {
  const reg =
    /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
  const result = txt.replace(reg, function (item) {
    if (item.search("http") < 0 && item.search("HTTP") < 0) {
      return (
        '<a href="' + "http://" + item + '" target="_blank">' + item + "</a>"
      );
    } else {
      return "<a href='" + item + "' target='_blank'>" + item + "</a>";
    }
  });
  return result;
};


const copyclass = (eleClass, data) => {

  if (data != "" && data != null && data != undefined) {
    let clipboard = new Clipboard("." + eleClass, {
      text: () => {
        return data;
      },
    });
    clipboard.on("success", (e) => {
      // 释放内存
      clipboard.destroy();
      Toast({
        message: t('tips.copySuccess'),
        position: 'middle',
      })
    });
    clipboard.on("error", (e) => {
      console.log("浏览器不支持复制");
      // 释放内存
      clipboard.destroy();
    });
  } else {

  }
};


const __returned__ = { zbgg, copy_id, vip0, vip1, vip2, vip3, vip4, vip5, roomZb, welcome_icon, t, ConfigpiniaStore, msgShield, chat_ad_interval, web_pm_tips, userStore, roomStore, isYk, user, addMsgList, roomSendMsg, addMsgItem, delMsg, changeMsgAD, isJoin, msgList, roomId, active, route, room_key, anchor_id, marqueeColor, marqueeFontColor, mainColor, scrollerRef, inputValue, onsend10, props, scrollIntoView, resetResize, showAlertUser, alertUserData, sendTimeout, setTime, sendServer, GetAD, newAD, anchor_announcement, t1, new_title_h, ispack_up, room_ad_status, getAdFn, joinUser, showAnimation, showAnimationTime, showAnimationRef, numInterval, scrollToBottom, isScrollBottom, handleScroll, sendtime, sendMsg, openBiaoqing, getUidByFid, onMsgChatClick, updateScrollTop, getLV, getNickNameColor, showShare, selBq, bqSwpierList, toAD, scrollDisabled, timeout, debounce, changeInputType, checkMsgShield, toStart, clickHandle, handleFalse, msgurl, copyclass, LoginGif, ChatUtils, Platform, router, nativeToLogin, DynamicScroller, DynamicScrollerItem, biaoqing }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})